// components/TableRow.jsx
import { useState } from "react";
import ActionButtons from "./ActionButtons";
import Checkbox from "./Checkbox";
import { useNavigate } from "react-router-dom";
import FileViewModal from "./ViewModal";
import { FaTrash } from "react-icons/fa";
import { useAuthToken } from "../../hooks/useAuthToken";
import { deleteTaskService } from "../../services/tasksService";
import { toast } from "react-toastify";
import useUserTasks from "../../hooks/useUserTasks";
import TranslationSegmentsDiffModal from "./TranslationSegmentsDiffModal";

export const AdminOnly = ({ children }) => {
    const { isAdmin } = useAuthToken();
    if (!isAdmin) return null;
    return <>{children}</>;
};

const statusColors = {
    Completed: "text-green-600 border border-green-600 py-2 px-4 rounded-full",
    "Available": "text-yellow-600 border border-yellow-600 py-2 px-4 rounded-full",
    "Under Progress": "text-blue-600 border border-blue-600 py-2 px-4 rounded-full",
    // Optional: add more common statuses
    Pending: "text-gray-600 border border-gray-600 py-2 px-4 rounded-full",
    Delayed: "text-red-600 border border-red-600 py-2 px-4 rounded-full",
    Cancelled: "text-red-400 border border-red-400 py-2 px-4 rounded-full line-through",
};
const TableRow = ({ task, isSelected, onSelect, handleDownload }) => {

    const { setTasks } = useUserTasks();

    const [expanded, setExpanded] = useState(false);
    const [viewOpen, setViewOpen] = useState(false);
    const [showDiffModal, setShowDiffModal] = useState(false);
    const [selectedTaskId, setSelectedTaskId] = useState(null);

    const handleView = (taskId) => {
        setSelectedTaskId(taskId);
        setViewOpen(true);
    };

    const handleDiff = (taskId) => {
        setSelectedTaskId(taskId);
        setShowDiffModal(true);
    };

    const navigate = useNavigate();

    const handleEdit = (taskid) => {
        navigate(`/md-editor/${taskid}`);
    };


    const handleDelete = async (id) => {
        if (!window.confirm("Delete this task?")) return;
        try {
            await deleteTaskService(id);
            toast.success("Deleted successfully");
            window.location.reload();
            setTasks((prev) => prev.filter((t) => t.id !== id));
        } catch {
            toast.error("Delete failed");
        }
    };

    return (
        <>
            <tr className="border-b hover:bg-gray-50 transition">
                <td className="p-3 border border-gray-300 text-center">
                    <Checkbox
                        checked={isSelected}
                        onChange={() => onSelect(task.id)}
                    />
                </td>

                {/* <td className="p-3 border border-gray-300">{task.id}</td> */}

                <td
                    className="p-3 text-blue-600 cursor-pointer border border-gray-300 hover:text-blue-600"
                    onClick={() => setExpanded(!expanded)}
                >
                    {task.taskid
                        ? String(task.taskid).slice(0, 4) + "-" +
                        String(task.taskid).slice(4, 8) + "-" +
                        String(task.taskid).slice(8, 12) + "-" +
                        String(task.taskid).slice(12)
                        : '-'}
                </td>

                <td className="p-3 border border-gray-300">
                    {task.source_file} ({task.source_lang}-{task.target_lang})
                </td>

                <td className="p-3 border border-gray-300">
                    {task.words}
                </td>

                <td className="p-3 border border-gray-300">
                    {task.assigned_to}
                </td>
                <td className="p-3 border border-gray-300">
                    <span className={`font-medium ${statusColors[task.status] || "text-gray-600"}`}>
                        {task.status}
                    </span>
                </td>


                <td className="p-3 border border-gray-300">
                    <ActionButtons
                        onEdit={() => handleEdit(task.taskid)}
                        onDownload={() => handleDownload(task.taskid, task.target_file)}
                        onView={() => handleView(task.taskid)}
                        onDiff={() => {handleDiff(task.taskid);
                            console.log("Diff button clicked → task:", task.taskid);
                        }
                        }
                    />
                </td>
            </tr>

            {/* Expanded Row */}
            {expanded && (
                <tr>
                    <td colSpan="7" className="border border-gray-300 bg-gray-50">
                        <table className="w-full border border-gray-300 text-sm">
                            <tbody>
                                <tr>
                                    <td className="border border-gray-300 p-2 font-semibold w-1/4 bg-gray-100">
                                        Primary ID
                                    </td>
                                    <td className="border border-gray-300 p-2">
                                        {task.id}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-2 font-semibold w-1/4 bg-gray-100">
                                        Task ID
                                    </td>
                                    <td className="border border-gray-300 p-2">
                                        {task.taskid}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-2 font-semibold bg-gray-100">
                                        Source File Name
                                    </td>
                                    <td className="border border-gray-300 p-2">
                                        {task.source_file}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-2 font-semibold bg-gray-100">
                                        target File Name
                                    </td>
                                    <td className="border border-gray-300 p-2">
                                        {task.target_file}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-2 font-semibold bg-gray-100">
                                        Translation File Name
                                    </td>
                                    <td className="border border-gray-300 p-2">
                                        {task.tl_file ? task.tl_file : "-"}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-2 font-semibold bg-gray-100">
                                        Word Count
                                    </td>
                                    <td className="border border-gray-300 p-2">
                                        {task.words}
                                    </td>
                                </tr>


                                <tr>
                                    <td className="border border-gray-300 p-2 font-semibold bg-gray-100">
                                        Language Pair
                                    </td>
                                    <td className="border border-gray-300 p-2">
                                        {task.source_lang}-{task.target_lang}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-2 font-semibold bg-gray-100">
                                        Assigned By
                                    </td>
                                    <td className="border border-gray-300 p-2">
                                        {task.assigned_by}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-2 font-semibold bg-gray-100">
                                        Assigned To
                                    </td>
                                    <td className="border border-gray-300 p-2">
                                        {task.assigned_to}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-2 font-semibold bg-gray-100">
                                        Status
                                    </td>
                                    <td className="border border-gray-300 p-2">
                                        {task.status}
                                    </td>
                                </tr>


                                <tr>
                                    <td className="border border-gray-300 p-2 font-semibold bg-gray-100">
                                        Task Created date
                                    </td>
                                    <td className="border border-gray-300 p-2">
                                        {new Date(task.created_at)
                                            .toLocaleString("en-IN", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                second: "2-digit",
                                                hour12: false,
                                            })
                                            .replace(/\//g, "-")
                                            .replace(",", "")}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-2 font-semibold bg-gray-100">
                                        Task Updated date
                                    </td>
                                    <td className="border border-gray-300 p-2">
                                        {new Date(task.updated_at)
                                            .toLocaleString("en-IN", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                second: "2-digit",
                                                hour12: false,
                                            })
                                            .replace(/\//g, "-")
                                            .replace(",", "")}
                                    </td>
                                </tr>

                                <AdminOnly>
                                    <tr>

                                        <td className="border border-gray-300 p-2 font-semibold bg-gray-100">
                                            Delete Task
                                        </td>
                                        <button
                                            onClick={() => handleDelete(task.id)}
                                            className="flex items-center gap-2 
                                                                bg-red-500 text-white 
                                                                px-4 py-2 
                                                                text-sm font-medium
                                                                rounded-lg 
                                                                shadow-md
                                                                transition-all duration-300 ease-in-out
                                                                hover:bg-red-600 hover:shadow-lg hover:-translate-y-0.5
                                                                active:scale-95"
                                        >
                                            <FaTrash className="text-base" />
                                            Delete
                                        </button>

                                    </tr>
                                </AdminOnly>
                            </tbody>
                        </table>
                    </td>
                </tr>
            )}

            {selectedTaskId && viewOpen && (
                <FileViewModal
                    taskId={selectedTaskId}
                    isOpen={viewOpen}
                    onClose={() => setViewOpen(false)}
                    rtlSource={task?.source_lang?.toLowerCase()}
                    rtlTarget={task?.target_lang?.toLowerCase()}
                />
            )}

            {selectedTaskId && showDiffModal && (
                <TranslationSegmentsDiffModal
                    taskId={selectedTaskId}
                    isOpen={showDiffModal}
                    onClose={() => setShowDiffModal(false)}
                    rtlSource={task?.source_lang?.toLowerCase()}
                    rtlTarget={task?.target_lang?.toLowerCase()}
                />
            )}
        </>
    );
};

export default TableRow;
